import { useQuery } from '@tanstack/react-query';
import { scenarioApi } from '../api';
import { questKeys } from '@/shared/queryKeys';

/**
 * 시나리오 상세 brief — 이 시나리오의 애드코드 신청 기록(출처표기) 조회 (PR2 L2).
 *
 * 쿼리 키를 `['quests', ...]` 네임스페이스에 두는 게 핵심: 애드코드 신청(useRequestAdcode)
 * 성공 시 `['quests']` 광역 invalidate 에 이 쿼리가 prefix 매칭으로 자동 포함되어,
 * 신청 직후 별도 결선 없이 기록 섹션이 갱신된다.
 */
export function useAdcodeRequests(scenarioId: string | undefined) {
  return useQuery({
    queryKey: questKeys.adcodeRequests(scenarioId),
    queryFn: () => scenarioApi.fetchAdcodeRequests(scenarioId as string),
    enabled: !!scenarioId,
    staleTime: 30_000,
  });
}
